// src/components/Glyph.js
// The Elpis "Deadpan" glyph: a pixel-block face with an orange aura.
// mode: 'spin' (continuous rotation), 'drop' (falls in, lands, then spins), 'still'.
import React from 'react';

export const PAL = { K: '#0f0d2e', B: '#2b2966', H: '#4a46b0', W: '#fff8f0', P: '#f97316', O: '#f97316' };
export const ROWS = [
  '................',
  '...KKKKKKKKKK...',
  '..KBBBBBBBBBBK..',
  '.KBBHHBBBBBBBBK.',
  '.KBBBBBBBBBBBBK.',
  '.KBOOOOBBOOOOBK.',
  '.KBWWPPBBWWPPBK.',
  '.KBBBBBBBBBBBBK.',
  '.KBBBBBBBBBBBBK.',
  '.KBBBKKKKKKBBBK.',
  '.KBBBBBBBBBBBBK.',
  '..KBBBBBBBBBBK..',
  '...KKKKKKKKKK...',
  '................',
  '................',
  '................',
];

// Merge horizontal runs of one colour into single rects.
const RECTS = (() => {
  const out = [];
  ROWS.forEach((row, y) => {
    let x = 0;
    while (x < 16) {
      const c = row[x];
      if (c === '.') { x += 1; continue; }
      let e = x;
      while (e < 16 && row[e] === c) e += 1;
      out.push({ x, y: y + 1, w: e - x, fill: PAL[c] });
      x = e;
    }
  });
  return out;
})();

// Just the pixel art, for callers that do their own animation (e.g. the 404 walker).
export function GlyphArt({ size = 64 }) {
  return (
    <svg viewBox="0 0 16 16" width={size} height={size} shapeRendering="crispEdges" style={{ display: 'block' }}>
      {RECTS.map((r, i) => <rect key={i} x={r.x} y={r.y} width={r.w} height="1" fill={r.fill} />)}
    </svg>
  );
}

export default function Glyph({ size = 64, mode = 'spin', aura = true, className = '' }) {
  return (
    <span
      className={`eg eg-${mode}${aura ? ' eg-aura' : ''} ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span className="eg-body">
        <span className="eg-spinner">
          <svg viewBox="0 0 16 16" width={size} height={size} shapeRendering="crispEdges" style={{ display: 'block' }}>
            {RECTS.map((r, i) => <rect key={i} x={r.x} y={r.y} width={r.w} height="1" fill={r.fill} />)}
          </svg>
        </span>
      </span>
    </span>
  );
}
